/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  PositionRouter,
  PositionRouterInterface,
} from "../PositionRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "address",
        name: "_shortsTracker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_depositFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minExecutionFee",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "callbackTarget",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    name: "Callback",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collateralDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockGap",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeGap",
        type: "uint256",
      },
    ],
    name: "CancelDecreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockGap",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeGap",
        type: "uint256",
      },
    ],
    name: "CancelIncreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collateralDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "queueIndex",
        type: "uint256",
      },
    ],
    name: "CreateDecreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "queueIndex",
        type: "uint256",
      },
    ],
    name: "CreateIncreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "marginFeeBasisPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "referralCode",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "DecreasePositionReferral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collateralDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockGap",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeGap",
        type: "uint256",
      },
    ],
    name: "ExecuteDecreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockGap",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeGap",
        type: "uint256",
      },
    ],
    name: "ExecuteIncreasePosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "marginFeeBasisPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "referralCode",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "IncreasePositionReferral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "SetAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "callbackGasLimit",
        type: "uint256",
      },
    ],
    name: "SetCallbackGasLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minBlockDelayKeeper",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minTimeDelayPublic",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxTimeDelay",
        type: "uint256",
      },
    ],
    name: "SetDelayValues",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "depositFee",
        type: "uint256",
      },
    ],
    name: "SetDepositFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "increasePositionBufferBps",
        type: "uint256",
      },
    ],
    name: "SetIncreasePositionBufferBps",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "isLeverageEnabled",
        type: "bool",
      },
    ],
    name: "SetIsLeverageEnabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "longSizes",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "shortSizes",
        type: "uint256[]",
      },
    ],
    name: "SetMaxGlobalSizes",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minExecutionFee",
        type: "uint256",
      },
    ],
    name: "SetMinExecutionFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "SetPositionKeeper",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "referralStorage",
        type: "address",
      },
    ],
    name: "SetReferralStorage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "increasePositionRequestKeysStart",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "decreasePositionRequestKeysStart",
        type: "uint256",
      },
    ],
    name: "SetRequestKeysStartValues",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "WithdrawFees",
    type: "event",
  },
  {
    inputs: [],
    name: "BASIS_POINTS_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "callbackGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "cancelDecreasePosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "cancelIncreasePosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "_path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "_indexToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_collateralDelta",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_sizeDelta",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "_isLong",
            type: "bool",
          },
          {
            internalType: "address",
            name: "_receiver",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_acceptablePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_minOut",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_executionFee",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "_withdrawETH",
            type: "bool",
          },
          {
            internalType: "address",
            name: "_callbackTarget",
            type: "address",
          },
        ],
        internalType: "struct PositionRouter.DecreasePositionParams",
        name: "_params",
        type: "tuple",
      },
    ],
    name: "createDecreasePosition",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "_path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "_indexToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_minOut",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_sizeDelta",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "_isLong",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "_acceptablePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_executionFee",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "_referralCode",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "_callbackTarget",
            type: "address",
          },
        ],
        internalType: "struct PositionRouter.IncreasePositionParams",
        name: "params",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
    ],
    name: "createIncreasePosition",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "_path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "_indexToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_minOut",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_sizeDelta",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "_isLong",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "_acceptablePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_executionFee",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "_referralCode",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "_callbackTarget",
            type: "address",
          },
        ],
        internalType: "struct PositionRouter.IncreasePositionParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "createIncreasePositionETH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "decreasePositionRequestKeys",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decreasePositionRequestKeysStart",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "decreasePositionRequests",
    outputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "collateralDelta",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockTime",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "withdrawETH",
        type: "bool",
      },
      {
        internalType: "address",
        name: "callbackTarget",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "decreasePositionsIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "depositFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "executeDecreasePosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_endIndex",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "executeDecreasePositions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "executeIncreasePosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_endIndex",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_executionFeeReceiver",
        type: "address",
      },
    ],
    name: "executeIncreasePositions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feeReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
    ],
    name: "getDecreasePositionRequestPath",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
    ],
    name: "getIncreasePositionRequestPath",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
    ],
    name: "getRequestKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getRequestQueueLengths",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "increasePositionBufferBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "increasePositionRequestKeys",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "increasePositionRequestKeysStart",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "increasePositionRequests",
    outputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isLong",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "acceptablePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "executionFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockTime",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "hasCollateralInETH",
        type: "bool",
      },
      {
        internalType: "address",
        name: "callbackTarget",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "increasePositionsIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isLeverageEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isPositionKeeper",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxGlobalLongSizes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxGlobalShortSizes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTimeDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minBlockDelayKeeper",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minExecutionFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minTimeDelayPublic",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "referralStorage",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendValue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_callbackGasLimit",
        type: "uint256",
      },
    ],
    name: "setCallbackGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minBlockDelayKeeper",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minTimeDelayPublic",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxTimeDelay",
        type: "uint256",
      },
    ],
    name: "setDelayValues",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_depositFee",
        type: "uint256",
      },
    ],
    name: "setDepositFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_increasePositionBufferBps",
        type: "uint256",
      },
    ],
    name: "setIncreasePositionBufferBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isLeverageEnabled",
        type: "bool",
      },
    ],
    name: "setIsLeverageEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_longSizes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shortSizes",
        type: "uint256[]",
      },
    ],
    name: "setMaxGlobalSizes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minExecutionFee",
        type: "uint256",
      },
    ],
    name: "setMinExecutionFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setPositionKeeper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_referralStorage",
        type: "address",
      },
    ],
    name: "setReferralStorage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_increasePositionRequestKeysStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_decreasePositionRequestKeysStart",
        type: "uint256",
      },
    ],
    name: "setRequestKeysStartValues",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shortsTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type PositionRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PositionRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PositionRouter__factory extends ContractFactory {
  constructor(...args: PositionRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _vault: AddressLike,
    _router: AddressLike,
    _weth: AddressLike,
    _shortsTracker: AddressLike,
    _depositFee: BigNumberish,
    _minExecutionFee: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _vault,
      _router,
      _weth,
      _shortsTracker,
      _depositFee,
      _minExecutionFee,
      overrides || {}
    );
  }
  override deploy(
    _vault: AddressLike,
    _router: AddressLike,
    _weth: AddressLike,
    _shortsTracker: AddressLike,
    _depositFee: BigNumberish,
    _minExecutionFee: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _vault,
      _router,
      _weth,
      _shortsTracker,
      _depositFee,
      _minExecutionFee,
      overrides || {}
    ) as Promise<
      PositionRouter & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): PositionRouter__factory {
    return super.connect(runner) as PositionRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PositionRouterInterface {
    return new Interface(_abi) as PositionRouterInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): PositionRouter {
    return new Contract(address, _abi, runner) as unknown as PositionRouter;
  }
}
